export const messages = (state) => {
  return state.messages
}

export const chat = (state) => {
  return state.chat
}

export const conversation = (state) => {
  return state.conversation
}

export const chatWidget = (state) => {
  return state.chatWidget
}

export const channels = (state) => {
  return state.channels
}